import { smdProducts } from "./smdProducts";
import { radiologicProducts } from "./rlProducts";
import { antennaProducts } from "./antennaProducts";

export { smdProducts };
export { radiologicProducts };
export { antennaProducts };
export const radioLogicProducts = radiologicProducts;

const sampleProducts = [
  ...smdProducts,
  ...radioLogicProducts,
  ...antennaProducts,
];

export default sampleProducts;
